<template>
	<div class="fixed inset-0 bg-black/50 backdrop-blur-md flex items-center justify-center z-40">
		<div class="popup-bg rounded-2xl p-6 w-10/12 md:w-3/6 lg:w-1/3 xl:w-1/4 animate-scale-in shadow-2xl relative">
			<button @click="$emit('cancel')" class="absolute top-4 right-4">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close" class="w-4 h-4"/>
			</button>

			<h2 class="text-xl font-archivomedium text-[var(--accent-color)] mb-4 text-center">
				Remove Token
			</h2>

			<p class="text-sm font-archivolight text-[var(--secondary-text-color)] mb-6 text-center">
				Are you sure you want to remove this asset from the Web App frontend?
			</p>

			<p class="text-xs italic font-archivolight text-[var(--secondary-text-color)] mb-6 text-center">
				Please note: You can import the contract again to view your balance. 
			</p>

			<div class="flex space-x-4">
				<button	@click="$emit('confirm')" class="flex-1 py-2 bg-[var(--accent-color)] text-white rounded-full hover:opacity-90 transition">
					Remove 
				</button>

				<button @click="$emit('cancel')" class="flex-1 py-2 bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition">
					Cancel
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';

	const props = defineProps({
		currentTheme: { type: String, required: true }
	});

	const emit = defineEmits(['confirm', 'cancel']);
</script>

<style scoped>
	.popup-bg {
		background: var(--popup-bg-color);
	}
</style>
